<template>
  <div :class="['dealer', programStyle]">
    <div class="dealer flex-column" v-if="selectedDealer && selectedDealer !== 'empty'">
      <div class="warning-banner" v-if="domainMessages">
        <div v-for="message in domainMessages" class="warning-text" :key="message.id">
          <img v-if="message.icon === 'Stop'" src="@/assets/new/stop_white.png" />
          <img v-if="message.icon === 'Calendar'" src="@/assets/new/calendar_white.png" />
          <img v-if="message.icon === 'Yield'" src="@/assets/new/warning_white.png" />
          <span>{{ message.globalMessage }}</span>
        </div>
      </div>
      <div
        v-if="
          activeNavTab &&
          routeName !== 'Dealer-Help' &&
          routeName !== 'Dealer-Security-Center' &&
          routeName !== 'Profile'
        "
        :class="['title-container', activeNavTab.key === 'Pillars' ? 'sticky' : '']"
      >
        <div class="info-container flex-column">
          <div class="dealer-details flex-row">
            <span class="title">{{ selectedDealer.dealerName }}</span>
            <div class="right flex-column">
              <div>
                <span>
                  <span class="label">{{ $t('dealer-code') }}:</span> {{ selectedDealer.entity }} |
                </span>
                <span>
                  <span class="label">{{ $t('sales-district') }}:</span> {{ selectedDealer.salesDistrict }}
                </span>
              </div>
              <div>
                <span>
                  <span class="label">{{ $t('service-district') }}:</span> {{ selectedDealer.serviceDistrict }} |
                </span>
                <span
                  ><span class="label">{{ $t('sales-group') }}:</span> {{ selectedDealer.groupSize }}</span
                >
              </div>
            </div>
          </div>
          <div class="subtitle-container">
            <div
              v-for="(program, index) in programs"
              :class="{ subtitle: true, active: programName ? programName === program.domain : false }"
              :key="program.domain"
              @click="goToProgram(program)"
            >
              <span class="breadcrumb"></span>{{ program.breadCrumb }}
              <span class="divider" v-if="index !== programs.length - 1">|</span>
            </div>
          </div>
        </div>
      </div>
      <div class="warning-banner" v-if="entityMessage">
        <div class="warning-text" v-for="message in entityMessage" :key="message.message">
          <img src="@/assets/new/warning_white.png" />
          <span>{{ message.message }}</span>
        </div>
      </div>
      <div
        v-if="surveyInterference && (routeName === 'Dashboard' || routeName === 'Pillars' || routeName === 'Dealer')"
        class="survey-interference flex-column"
      >
        <p class="title">{{ $t('survey-interference-notice') }}</p>
        <div class="notice">
          <p>{{ $t('survey-interference-message') }}</p>
          <br />
          <p>{{ $t('si-note') }}</p>
        </div>
        <div class="dealer-info">
          <p class="section-title">{{ $t('sid-records') }}</p>
          <div v-if="dealers.length">
            <ul>
              <li v-for="dealer in dealers" :key="dealer.userId">
                <p>{{ dealer.userId }} {{ dealer.firstName }} {{ dealer.lastName }}</p>
              </li>
            </ul>
          </div>
          <div v-else>
            <p>{{ $t('no-sid-records') }}</p>
          </div>
        </div>
        <div class="button-container flex-row">
          <button v-if="surveyPermission === 'Y'" @click="goToForms">{{ $t('view-forms') }}</button>
          <button v-if="skipSI" @click="updateSI">{{ $t('continue') }}</button>
        </div>
      </div>
      <div
        v-if="
          !surveyInterference ||
          (surveyInterference && routeName !== 'Dashboard' && routeName !== 'Pillars' && routeName !== 'Dealer')
        "
        class="content"
      >
        <router-view
          v-if="domain && entity"
          :selectedDealer="selectedDealer"
          :trackerInfo="trackerInfo"
          :pillarDetails="pillarDetails"
          :entity="entity"
        />
      </div>
    </div>
    <div v-if="selectedDealer === 'empty'" class="empty">
      <div
        v-if="
          activeNavTab &&
          routeName !== 'Dealer-Help' &&
          routeName !== 'Dealer-Security-Center' &&
          routeName !== 'Profile'
        "
        :class="['title-container', activeNavTab.key === 'Pillars' ? 'sticky' : '']"
      >
        <div class="info-container flex-column">
          <div class="dealer-details flex-row">
            <span class="title">{{ dealerInfo.dealerName }}</span>
            <div class="right flex-column">
              <div>
                <span>
                  <span class="label">{{ $t('dealer-code') }}:</span> {{ dealerInfo.entity }} |
                </span>
                <span>
                  <span class="label">{{ $t('sales-district') }}:</span> {{ dealerInfo.salesDistrict }}
                </span>
              </div>
              <div>
                <span>
                  <span class="label">{{ $t('service-district') }}:</span> {{ dealerInfo.serviceDistrict }} |
                </span>
                <span
                  ><span class="label">{{ $t('sales-group') }}:</span> {{ dealerInfo.groupSize }}</span
                >
              </div>
            </div>
          </div>
          <div class="subtitle-container">
            <div
              v-for="(program, index) in programs"
              :class="{ subtitle: true, active: programName ? programName === program.domain : false }"
              :key="program.domain"
              @click="goToProgram(program)"
            >
              <span class="breadcrumb"></span>{{ program.breadCrumb }}
              <span class="divider" v-if="index !== programs.length - 1">|</span>
            </div>
          </div>
        </div>
      </div>
      <span class="error-message">{{ $t('no-programs-dealer') }}</span>
    </div>
    <LegendComponent
      v-if="(routeName === 'Dashboard' || routeName === 'Pillars') && !surveyInterference && selectedDealer !== 'empty'"
    />
  </div>
</template>

<script>
import LegendComponent from '@/components/LegendComponent.vue';
import { mapState } from 'vuex';

export default {
  name: 'Dealer',
  components: { LegendComponent },
  data() {
    return {
      selectedDealer: null,
      programBool: false,
      pillarDetails: [],
      trackerInfo: [],
      dealers: [],
      ignoreSI: false,
      dealerInfo: null,
      domainsInfo: null,
      currentTimeMilliseconds: null,
      currentTimeSeconds: null,
    };
  },
  methods: {
    getEntity() {
      const loader = this.$loading.show();
      const { domain, entity } = this;

      this.$store.dispatch('global/getEntity', { domain, entity }).then((res) => {
        if (res) {
          this.selectedDealer = res;
          this.$store.state.selectedDealer = this.selectedDealer;
        } else {
          this.selectedDealer = 'empty';
        }
        this.checkSurveyInterference();
        loader.hide();
      });
    },

    // If User chooses to ignore SI, don't need to call request.
    checkSurveyInterference() {
      const { domain, entity } = this;
      if (!this.ignoreSI) {
        this.$store.dispatch('surveyInterference', { domain, entity }).then((res) => {
          if (res) {
            this.$store.state.surveyInterference = res.isLocked;
            this.$store.state.surveyPermission = res.acknowledgementPermission;
          }
          if (this.$store.state.surveyInterference) {
            this.$store.state.activeNavTab = 'SI';
            this.getPrograms();
            this.getDealers();
          } else {
            this.$store.state.surveyInterference = false;
            this.getPrograms();
            this.getPeriods();
          }
        });
      } else {
        this.getPeriods();
      }
    },
    getDealers() {
      const { domain, entity } = this;
      this.$store.dispatch('getDealers', { domain, entity }).then((res) => {
        this.dealers = res.dealers;
      });
    },
    async getPrograms() {
      const { entity } = this;
      if (!this.programs) {
        await this.$store.dispatch('global/getPrograms', { entity }).then((res) => {
          if (res) {
            this.$store.state.global.programs = res.programProps;
            this.dealerInfo = res.entityInfo;
            this.programs.forEach((program) => {
              if (this.$store.state.global.programName === program.domain) {
                this.$store.state.global.programImage = program.programGraphic;
                this.$store.state.global.programStyle = program.lookAndFeel;
                this.$store.state.programBreadcrumb = program.breadCrumb;
                if (program.languages && this.userType === 'Dealer') {
                  this.updateLang(program.languages);
                }
              }
            });
          }
        });
      } else {
        this.programs.forEach((program) => {
          if (this.$store.state.global.programName === program.domain) {
            this.$store.state.global.programImage = program.programGraphic;
            this.$store.state.global.programStyle = program.lookAndFeel;
            this.$store.state.programBreadcrumb = program.breadCrumb;
            if (program.languages && this.userType === 'Dealer') {
              this.updateLang(program.languages);
            }
          }
        });
      }
    },
    goToProgram(program) {
      if (program.domain !== this.$store.state.global.programName) {
        const { entity } = this;

        this.$router.push(`/dealer/${program.domain}/${entity}/dashboard`);
        this.$store.state.global.programName = program.domain;
        this.$store.state.global.programImage = program.programGraphic;
        this.$store.state.global.programStyle = program.lookAndFeel;
        this.$store.state.programBreadcrumb = program.breadCrumb;
        this.getEntity();
      }
    },
    getPeriods() {
      const loader = this.$loading.show();

      const { domain, entity } = this;

      this.$store
        .dispatch('getPeriods', { domain, entity })
        .then((res) => {
          this.periods = res;
          this.$store.state.periods = this.periods;
          this.$store.state.activePeriod = this.periods.find((item) => item.defaultPeriod === 'Y');
          this.$store.state.appealable = this.periods.some((item) => item.appealable === true);
          if (!this.$store.state.activePeriod) {
            this.$store.state.activePeriod = res[0];
          }
          this.$store.state.defaultPeriod = this.$store.state.activePeriod.period;
          if (!this.programs) {
            Promise.all([
              this.getPrograms(),
              this.getTrackerInfo(),
              this.getPillarInfo(),
              this.getMessages(),
              this.getAppealInfo(),
            ]).finally(() => {
              this.$router.push({
                name: 'Dashboard',
              });
            });
          } else {
            Promise.all([
              this.getPillarInfo(),
              this.getTrackerInfo(),
              this.getMessages(),
              this.getAppealInfo(),
            ]).finally(() => {
              this.$router.push({
                name: 'Dashboard',
              });
            });
          }
        })
        .catch((error) => {
          this.getDomainsInfo();
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getPillarInfo() {
      const { domain, period, entity } = this;

      return this.$store.dispatch('getPillars', { domain, period, entity }).then((res) => {
        this.pillarDetails = res;
        this.pillarDetails.forEach((pillar) => {
          this.$set(pillar, 'show', true);
        });
      });
    },
    getMessages() {
      const { domain, period, entity } = this;

      return this.$store.dispatch('getMessages', { domain, period, entity }).then((res) => {
        if (res.programMessages.length > 0) {
          this.$store.state.domainMessages = res.programMessages;
          this.setMessageEndTime(this.domainMessages);
        } else {
          this.$store.state.domainMessages = null;
        }
        if (res.periodMessages.length > 0) {
          this.$store.state.periodMessages = res.periodMessages;
          this.setMessageEndTime(this.periodMessages);
        } else {
          this.$store.state.periodMessages = null;
        }
        if (res.entityPeriodMessages.length > 0) {
          this.$store.state.entityPeriodMessages = res.entityPeriodMessages;
          this.setMessageEndTime(this.entityPeriodMessages);
        } else {
          this.$store.state.entityPeriodMessages = null;
        }
      });
    },
    setMessageEndTime(messages) {
      messages.forEach((message) => {
        const endDate = new Date(message.endDate);
        message.messageEndTime = Math.floor(endDate.getTime());
      });
    },
    getTrackerInfo() {
      const { entity, domain } = this;

      return this.$store.dispatch('getTrackers', { domain, entity }).then((res) => {
        this.trackerInfo = res;
        this.trackerInfo.forEach((tracker) => {
          if (tracker.trackerStatus) {
            this.$set(tracker, 'show', false);
          } else {
            this.$set(tracker, 'show', null);
          }
        });
      });
    },
    getAppealInfo() {
      const { domain, entity, period } = this;
      this.$store.dispatch('getAppealableDials', { domain, entity, period }).then((res) => {
        this.$store.state.appealInfo = res;
      });
    },
    goToForms() {
      this.$router.push({
        name: 'Dealer-Forms',
      });
    },
    isEmpty(obj) {
      if (obj) {
        return Object.keys(obj).length === 0;
      }
      return false;
    },
    updateLang(languages) {
      const newLanguages = [];
      languages.forEach((language) => {
        let languageObj = {};

        languageObj = {
          code: language.language.toLowerCase(),
          name: language.languageName,
        };
        newLanguages.push(languageObj);
      });
      if (newLanguages) {
        this.$store.dispatch('updateLanguages', newLanguages);
      }
    },
    updateSI() {
      this.ignoreSI = true;
      this.$store.state.surveyInterference = false;
    },
    getProgramLogo() {
      const { domain } = this;
      const index = this.domainsInfo.findIndex((domainObj) => domainObj.domain === domain);
      this.$store.state.global.programImage = this.domainsInfo[index].programGraphic;
    },
    getDomainsInfo() {
      const loader = this.$loading.show();

      this.$store
        .dispatch('getDomainsInfo')
        .then((res) => {
          if (res && res.length > 0) {
            this.domainsInfo = res;
            this.getProgramLogo();
          }
          loader.hide();
        })
        .catch(() => {
          loader.hide();
        });
    },
    setUpTime() {
      this.getCurrentTimeMilliseconds();
      setInterval(this.getCurrentTimeMilliseconds, 1);
      this.getCurrentTimeSeconds();
      setInterval(this.getCurrentTimeSeconds, 1000);
    },
    getCurrentTimeMilliseconds() {
      this.currentTimeMilliseconds = Date.now();
    },
    getCurrentTimeSeconds() {
      const now = new Date();
      this.currentTimeSeconds = now.getSeconds();
    },
  },
  computed: {
    domain() {
      if (this.routeParams) {
        return this.$route.params.domain;
      }

      return this.loginInfo.domain;
    },
    entity() {
      if (this.routeParams) {
        return this.$route.params.entity;
      }

      return this.loginInfo.entity;
    },
    routeParams() {
      return !this.isEmpty(this.$route.params);
    },
    ...mapState('global', ['programs', 'programStyle', 'programName', 'navPermissions']),
    ...mapState([
      'userType',
      'domainMessages',
      'entityMessage',
      'periodMessages',
      'entityPeriodMessages',
      'activeNavTab',
      'surveyInterference',
      'surveyPermission',
    ]),
    period() {
      if (this.$store.state.activePeriod) {
        return this.$store.state.activePeriod.period;
      }
      return null;
    },
    routeName() {
      return this.$route.name;
    },
    loginInfo() {
      return this.$store.state.login.loginInfo;
    },
    skipSI() {
      if (this.navPermissions) {
        return this.navPermissions.some((permission) => permission.navGroup === 'skipSI');
      }
      return false;
    },
  },
  watch: {
    programName() {
      this.$store.state.activePeriod = null;
      this.$store.state.domainMessages = null;
      this.$store.state.periodMessages = null;
    },
    period(newPeriod, oldPeriod) {
      if (oldPeriod !== null && newPeriod !== null) {
        const loader = this.$loading.show();
        Promise.all([this.getPillarInfo(), this.getAppealInfo(), this.getMessages()]).finally(() => {
          loader.hide();
        });
      }
    },
    surveyInterference(oldInterference, newInterference) {
      if (oldInterference === false && newInterference === true) {
        this.getEntity();
      }
    },
    currentTimeSeconds() {
      if (this.domainMessages && this.domainMessages.length > 0) {
        // Make api call to getMessages() if message has expired.
        if (this.domainMessages.some((message) => this.currentTimeMilliseconds >= message.messageEndTime)) {
          this.getMessages();
        }
      }
      if (this.periodMessages && this.periodMessages.length > 0) {
        // Make api call to getMessages() if message has expired.
        if (this.periodMessages.some((message) => this.currentTimeMilliseconds >= message.messageEndTime)) {
          this.getMessages();
        }
      }
      if (this.entityPeriodMessages && this.entityPeriodMessages.length > 0) {
        // Make api call to getMessages() if message has expired.
        if (this.entityPeriodMessages.some((message) => this.currentTimeMilliseconds >= message.messageEndTime)) {
          this.getMessages();
        }
      }
    },
  },
  created() {
    const providedDomain = !this.isEmpty(this.$route.params);
    if (providedDomain) {
      this.$store.state.global.programName = this.$route.params.domain;
      this.$router.push({
        path: `/dealer/${this.$route.params.domain}/${this.$route.params.entity}/dashboard`,
      });
      this.getEntity();
    } else if (this.userType === 'Field User') {
      this.$router.push({
        name: 'Programs',
      });
    } else {
      const { domain, entity } = this.loginInfo;
      this.$store.state.global.programName = domain;
      this.$router.push({
        path: `/dealer/${domain}/${entity}/dashboard`,
      });
      this.getEntity();
    }
    this.setUpTime();
  },
};
</script>

<style lang="scss" scoped>
.dealer {
  width: 100%;
}
.title-container {
  display: flex;
  flex-direction: row;
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 35px 30px 30px;
  justify-content: space-between;
  &.sticky {
    position: sticky;
    top: 0px;
    z-index: 2;
    background: white;
    min-height: 57px;
  }
  .info-container {
    width: 100%;
    .dealer-details {
      .title {
        font-size: 32px;
        font-weight: bold;
        text-transform: uppercase;
        line-height: 38px;
        width: 100%;
      }
      .right {
        color: $primary-black;
        font-size: 14px;
        line-height: 20px;
        text-align: right;
        white-space: nowrap;
        .label {
          font-weight: bold;
        }
      }
    }
  }
  .subtitle-container {
    display: flex;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    display: flex;
    cursor: pointer;
    &.active {
      text-decoration: none;
      font-weight: bold;
      cursor: default;
      text-transform: uppercase;
    }
    .breadcrumb {
      text-decoration: underline;
    }
    .divider {
      margin: 0 5px;
      font-weight: 500;
    }
  }
}
.empty {
  .title-container {
    margin-bottom: 22%;
  }
}
.survey-interference {
  text-align: left;
  padding: 30px;
  p {
    margin: 0px;
    color: $primary-black;
  }
  .title {
    font-size: 18px;
    line-height: 24px;
    font-weight: bold;
    text-transform: uppercase;
    color: $primary;
  }
  .notice {
    margin: 30px 0px;
  }
  .dealer-info {
    margin-bottom: 45px;
    text-transform: uppercase;
    .section-title {
      font-weight: bold;
      margin-bottom: 30px;
    }
    ul {
      margin: 0px;
    }
  }
  button {
    margin-right: 20px;
  }
}
</style>
